// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navBar-module_container__imSrf {
    background-color: var(--white);
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    height: 0;
    pointer-events: none;
    z-index: var(--zindex-nav-bar);
}

.navBar-module_inner__mLyaY {
    box-sizing: border-box;
    margin: 0 auto;
    padding: 16px;
    position: absolute;
    right: 0;
    left: 0;
    top: 0;
    display: flex;
    justify-content: var(--justifyContent);
    max-width: 528px;

}

.navBar-module_innerInsideStories__JmB2C {
    padding: 42px 16px 16px 16px;
}

@media screen and (min-width: 481px) {
    .navBar-module_inner__mLyaY {
        max-width: 504px;
    }
}

@media screen and (min-width: 708px) {
    .navBar-module_inner__mLyaY {
        padding: 32px 16px;
        max-width: 100%;
    }

    .navBar-module_innerSearchBar__A7qss {
        padding: 0;
    }

    .navBar-module_innerInsideStories__JmB2C {
        padding: 42px 16px 16px 16px;
    }
}

@media screen and (min-width: 889px) {
    .navBar-module_inner__mLyaY {
        max-width: 888px;
    }
}`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/UI/NavBar/navBar.module.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,OAAO;IACP,eAAe;IACf,QAAQ;IACR,MAAM;IACN,SAAS;IACT,oBAAoB;IACpB,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,MAAM;IACN,aAAa;IACb,sCAAsC;IACtC,gBAAgB;;AAEpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".container {\n    background-color: var(--white);\n    left: 0;\n    position: fixed;\n    right: 0;\n    top: 0;\n    height: 0;\n    pointer-events: none;\n    z-index: var(--zindex-nav-bar);\n}\n\n.inner {\n    box-sizing: border-box;\n    margin: 0 auto;\n    padding: 16px;\n    position: absolute;\n    right: 0;\n    left: 0;\n    top: 0;\n    display: flex;\n    justify-content: var(--justifyContent);\n    max-width: 528px;\n\n}\n\n.innerInsideStories {\n    padding: 42px 16px 16px 16px;\n}\n\n@media screen and (min-width: 481px) {\n    .inner {\n        max-width: 504px;\n    }\n}\n\n@media screen and (min-width: 708px) {\n    .inner {\n        padding: 32px 16px;\n        max-width: 100%;\n    }\n\n    .innerSearchBar {\n        padding: 0;\n    }\n\n    .innerInsideStories {\n        padding: 42px 16px 16px 16px;\n    }\n}\n\n@media screen and (min-width: 889px) {\n    .inner {\n        max-width: 888px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `navBar-module_container__imSrf`,
	"inner": `navBar-module_inner__mLyaY`,
	"innerInsideStories": `navBar-module_innerInsideStories__JmB2C`,
	"innerSearchBar": `navBar-module_innerSearchBar__A7qss`
};
export default ___CSS_LOADER_EXPORT___;
